<template>
  <div class="main-container">
    <div class="row">
      <div class="col s12 offset-l1 l10 card-panel recargas"
           style=" margin-top: 15px; padding: 15px; border-radius: 10px;">
        <div class="row">
          <div class="col s12">
            <ol
                style=" font-size: 24px; margin-top: auto; margin-bottom: auto; list-style-type: none; display: inline-block; padding: 0.75rem 0 1rem;"
            >
              <li
                  class="elemento"
                  style="display: inline; cursor: pointer;"
                  @click="returndata"
              >
                <a class="return">
                  Dias de inventario
                </a>
              </li>
              <li style="display: inline;" v-if="data.leaderName && isLider">
                > {{ data.leaderName }}
              </li>
            </ol>
          </div>
        </div>
        <h5 class="center" style="margin-right: 0%;">
          {{ titulo }}
        </h5>
        <div class="row center-align" style="margin-bottom: 0%;">
          <div class="col s6 m3 offset-m3 l2 offset-l4 input-date" style="cursor: pointer;">
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
            />
            <div class="center-align" @click="dateIni">
            <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
            >today</span
            >
              <span
                  class="prefix"
                  style="font-size: 18px; width: 6rem; top: 0.2rem;"
              >Fecha Inicial:</span
              >
            </div>
            <input
                id="input-fecha-inicial"
                type="text"
                class="datepicker center-align"
                style="cursor: pointer;"
            />
          </div>

          <div class="col s6 m3 l2 input-date" style="cursor: pointer;">
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
            />
            <div class="center-align" @click="dateFin">
            <span
                class="material-symbols-outlined btn-style "
                style="position: relative; top: 4px;"
            >event</span
            >
              <span
                  class="prefix"
                  style="font-size: 18px; width: 6rem; top: 0.2rem;"
              >Fecha Final:</span
              >
            </div>
            <input
                id="input-fecha-final"
                type="text"
                class="datepicker center-align"
                style="cursor: pointer;"
            />
          </div>

        </div>

        <div class="row">
          <div class="input-field col offset-s4 s4 offset-m5 m2 offset-l5 l2 input-date">
            <input id="input-monto" type="text" v-model="data.monto"/>
            <label for="input-monto">Monto</label>
          </div>

        </div>


        <div id="app">
          <div class="col s6 left-align"></div>
          <div class="col s6 right-align">
            <div
                class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="toggleFiltros"
                data-position="top"
                :data-tooltip="mostrarFiltros ? 'Ocultar Filtros' : 'Mostrar Filtros'"
            >
              <link
                  rel="stylesheet"

                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span 
              class="material-symbols-outlined btn-style" >
              {{ mostrarFiltros ? 'filter_alt' : 'filter_alt_off' }}
            </span>
            </div>
            <div
                class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="generarExcel"
                data-position="top"
                data-tooltip="Generar Excel"
            >
              <i class="fa fa-file-excel-o " aria-hidden="true"></i>
            </div>
          </div>

          <div class="row" v-show="mostrarFiltros">
            <div
                class="column col s6 m6 l2 xl2"
                v-for="titulo in titulos"

            >
              <div class="chips validate input-filtros" :id="titulo.llave">
                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col s12 offset-l1 l10 card-panel recargas" style="position: relative; border-radius: 10px;">

        <table
            class="responsive-table striped highlight"
            style="text-align-last: center"
        >
          <thead>
          <tr>
            <th>#</th>
            <th v-for="titulo in titulos">
              <div v-if="data.leaderName && titulo.llave == 'cliente'">
                {{ titulo.valor }}
              </div>
              <div v-else-if="!data.leaderName && titulo.llave == 'lider'">
                {{ titulo.valor }}
              </div>
              <div
                  v-else-if="titulo.llave != 'cliente' && titulo.llave != 'lider'"
              >
                {{ titulo.valor }}
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(row, index) in agregar100"
              :style="`${isLider && !data.leaderName ? 'cursor: pointer' : ''} `"
          >
            <td>{{ index + 1 }}</td>
            <td v-for="title in titulos" @click="detail(row.lider)">
              <p v-if="data.leaderName && titulo.llave == 'cliente'">
                {{ row[title.llave] }}
              </p>
              <p v-else></p>
              <p v-if="!data.leaderName && titulo.llave == 'lider'">
                {{ row[title.llave] }}
              </p>
              <p v-else></p>
              <p v-if="titulo.llave != 'cliente' && titulo.llave != 'lider'">
                {{ row[title.llave] }}
              </p>
              <p v-else></p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import {i18n} from "@/constantes";
import {inventoryDays, inventoryDaysRoute} from "../api/portOuts";
import {creaExcel} from "@/api/api";

let chipJs = {};
let filterParams = [];
let filtros = {};
let copyTitulos = [];
export default {
  name: "inventoryDays",
  data() {
    return {
      /*       titles: {}, */
      titulos: [
        {llave: "lider", valor: "Lider"},
        {llave: "cliente", valor: "Cliente"},
        {llave: "compañia", valor: "Compañia"},
        {llave: "entregados", valor: "Entregados"},
        {llave: "recargados", valor: "Recargados"},
        {llave: "vendidos", valor: "Vendidos"},
        {llave: "portabilidades", valor: "Portados"},
        {llave: "tipo", valor: "Tipo"},
        {llave: "total", valor: "Inventario Actual"},
        {llave: "inventoryDays", valor: "Dias de inventario"},
      ],
      rows: [],
      filteredRows: [],
      cuerpos: [],
      usuarioSeleccionado: "0",
      data: {
        monto: "",
        leaderName: "",
      },
      titulo: "",
      isLider: window.localStorage.nivel == 1 ? true : false,
      miNivel: window.localStorage.nivel,
      mostrarFiltros: true,
      chips: [],
      chipsOptions: {
        onChipAdd: this.addChip,
        onChipDelete: this.deleteChip,
      },
      datosRecibios: [],
      datosAMostrar: [],
      indexScroll: 1,
    };
  },
  computed: {
    computedList() {
      this.datosAMostrar = this.datosRecibios.slice();
      console.log(this.titulo);
      if (this.chips.length) {
        let auxChips = this.chips.slice();
        let chipsArray = [];
        while (auxChips.length) {
          let chip = auxChips[0];
          chipsArray.push(
              auxChips.filter((auxChip) => auxChip.key == chip.key)
          );
          auxChips = auxChips.filter((auxChip) => auxChip.key != chip.key);
        }
        let auxDatosAMostrar = this.datosAMostrar.slice();
        chipsArray.forEach((element) => {
          auxDatosAMostrar = auxDatosAMostrar.filter((item) => {
            return element.some((titulo) => {
              return item[titulo.key]
                  .toUpperCase()
                  .includes(titulo.value.toUpperCase());
            });
          });
        });
        this.datosAMostrar = auxDatosAMostrar;
        console.log("Termino");
        console.log(this.datosAMostrar.length);
      }
      return this.datosAMostrar;
    },
    agregar100() {
      return this.computedList.slice(0, 20 * this.indexScroll);
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.init()
        this.initChips()
      }, 1000)
    })
    this.getInventory();
    this.getInventoryRoute();

    $(window).scroll(() => {
      if (
          $(document).height() <
          $(window).scrollTop() + $(window).height() + 50
      ) {
        /*    this.agregar100(); */
        this.indexScroll++;
      }
    });
  },
  updated() {
    this.$nextTick(() => {
      if (window.localStorage.nivel >= `2`)
        this.data.leaderName = window.localStorage.lider;
      this.init();
    });
  },
  methods: {
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    handleFocusOut(llave) {
      const inputId = "input-" + llave;
      const input = document.getElementById(inputId);
      input.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
          })
      );
    },
    initChips() {
      console.log("options: ", this.chipsOptions);
      this.titulos.forEach((titulo) => {
        const elems = document.getElementById(titulo.llave);
        const chipsOptions = {
          ...this.chipsOptions,
          key: titulo.llave,
          placeholder: `${titulo.valor}`,
        };
        console.log(elems, titulo, chipsOptions, "opcionesssss");
        const chip = M.Chips.init(elems, chipsOptions);
        console.log(chipJs);
        chipJs[`${titulo.llave}`] = chip;
      });
    },
    deleteChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips = this.chips.filter(
          (c) => !(c.key === key && c.value === value)
      );
      console.log(this.chips);
    },
    addChip(a, b) {
      console.log(a, b);
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips.push({key, value});
    },
    dateIni() {
      const elem = document.getElementById("input-fecha-inicial");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
      console.log("wea");
    },
    dateFin() {
      const elem = document.getElementById("input-fecha-final");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
    },
    returndata() {
      this.data = {};
      this.getInventory();
    },
    quitarFiltros() {
      this.titulos.forEach((titulo) => {
        const auxTitulo = titulo.llave;
        if (chipJs[auxTitulo] && chipJs[auxTitulo].chipsData.length > 0) {
          console.log(
              chipJs[auxTitulo].chipsData.length,
              `estos son los chips de ${auxTitulo}`
          );
          while (chipJs[auxTitulo].chipsData.length > 0) {
            chipJs[auxTitulo].deleteChip(0);
          }
        }
      });

      this.chips = [];
    },
    init() {
      this.$nextTick(() => {
        M.Datepicker.init(document.querySelectorAll(".datepicker"), {
          format: "yyyy/mm/dd",
          i18n: i18n,
          onClose: () => {
            this.consultar();
          },
        });
      });
    },
    detail(lider) {
      console.log(this.filteredRows);
      this.quitarFiltros();
      if (this.data.leaderName) return;
      this.data.leaderName = lider;
      this.getInventory();
    },
    consultar() {
      this.datosRecibios = [];
      this.datosAMostrar = [];
      this.titles = []
      this.rows = [];
      this.filteredRows = [];
      this.titulo = ``;

      const fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      const fechaFin = document
          .getElementById("input-fecha-final")
          .value.trim();
      if (fechaIni !== "" && fechaFin === "") return;
      else if (fechaIni === "" && fechaFin !== "") return;
      if (fechaIni === "" && fechaFin === "" && this.data.monto === "") return;
      console.log(`pasamos, pasammos!`);
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        this.data.initialDay = fechaSeparada[2];
        this.data.initialMonth = fechaSeparada[1];
        this.data.initialYear = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        this.data.finalDay = fechaSeparada[2];
        this.data.finalMonth = fechaSeparada[1];
        this.data.finalYear = fechaSeparada[0];
      }
      const auxLider =
          this.usuarioSeleccionado === "0" ? undefined : this.usuarioSeleccionado;
      inventoryDays(this)
          .then((response) => {
            console.log(response)
            response.rows = response.rows.map((row) => {
              return {
                ...row,
                entregados: `${row.entregados}`,
                recargados: `${row.recargados}`,
                portabilidades: `${row.portabilidades}`,
                total: `${row.total}`,
                cliente: row.cliente ? row.cliente : "",
                lider: row.lider ? row.lider : "",
              };
            });
            this.datosRecibios = this.datosRecibios.concat(response.rows.slice());
            this.datosAMostrar = this.datosAMostrar.concat(response.rows.slice());
            this.titulo = `${this.datosRecibios.length} encontrados`;

            this.rows = response.rows;
            console.log(this.rows)
            this.filteredRows = response.rows;
            this.titulo = `${this.filteredRows.length} resultados`;
            this.$nextTick(() => M.updateTextFields());
          })
          .catch((error) => {
            console.log(error);
          });
    },
    generarExcel() {
      const fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      const fechaFin = document
          .getElementById("input-fecha-final")
          .value.trim();
      //if (fechaFin === "" || fechaFin === '') return
      let filtros = {};
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        filtros.initialDay = fechaSeparada[2];
        filtros.initialMonth = fechaSeparada[1];
        filtros.initialYear = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        filtros.finalDay = fechaSeparada[2];
        filtros.finalMonth = fechaSeparada[1];
        filtros.finalYear = fechaSeparada[0];
      }

      if (this.data.leaderName) {
        filtros.leaderName = this.data.leaderName;
      }
      const auxLider =
          this.usuarioSeleccionado === "0" ? undefined : this.usuarioSeleccionado;
      console.log(12321321);
      creaExcel(filtros, "InventoryDays")
          .then((response) => {
            this.$store.commit("quitarBarra");
            //console.log(response.data)
            window.location = `https://recarga-te.com/excel?nombre=${response.data.nombreArchivo}`;
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
            M.toast({
              html: "No se pudo crear el excel",
              classes: "rounded",
              displayLength: 3000,
            });
          });
    },
    getInventory() {
      this.datosRecibios = [];
      this.datosAMostrar = [];
      this.titles = []
      this.rows = [];
      this.filteredRows = [];
      this.titulo = ``;
      inventoryDays(this)
          .then((response) => {
            response.rows = response.rows.map((row) => {
              return {
                ...row,
                entregados: `${row.entregados}`,
                recargados: `${row.recargados}`,
                portabilidades: `${row.portabilidades}`,
                total: `${row.total}`,
                cliente: row.cliente ? row.cliente : "",
                lider: row.lider ? row.lider : "",
              };
            });
            this.datosRecibios = this.datosRecibios.concat(response.rows.slice());
            this.datosAMostrar = this.datosAMostrar.concat(response.rows.slice());
            //this.titulo = `${this.datosRecibios.length} encontrados`;

            this.rows = response.rows;
            this.filteredRows = response.rows;
            this.titulo = `${this.filteredRows.length} resultados`;
            this.$nextTick(() => M.updateTextFields());
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getInventoryRoute() {
      inventoryDaysRoute(this)
          .then((response) => {
          })
          .catch((error) => {
            console.log(error);
          });
    },
    /*     filter(event) {
      filtros[event.target.id] = event.target.value;
      this.cuerpos = [];
      this.$nextTick(() => M.updateTextFields());
      this.filteredRows = this.rows.slice();
      console.log(filtros);
      Object.keys(filtros).forEach((llave) => {
        const auxFiltro = filtros[llave];
        if (auxFiltro !== "")
          this.filteredRows = this.filteredRows.filter((fila) =>
            `${fila[llave]}`.includes(auxFiltro)
          );
      });

      this.titulo = `${this.filteredRows.length} resultados`;
      this.agregar100();
    }, */
  },
};
</script>
<style scoped>
.return {
  color: rgba(0, 0, 0, 0.623);
  text-decoration: none;
}

.return:hover {
  text-decoration: underline;
  color: #26a69a;
  cursor: pointer;
}

li {
  color: rgba(0, 0, 0, 0.623);
}

.btn {
  width: 70px;
  text-align-last: center;
}

.btn-style {
  margin-top: 5px;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}


@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }

  th {
    height: 63px;
    max-height: 63px;
  }

  td {
    height: 63px;
    max-height: 63px;
  }

  .titulo {
    font-size: 2rem;
  }
}

.datepicker {
  border-bottom: none !important;
}
</style>
